import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send } from 'lucide-react';

import {
  FaFacebook,
  FaInstagram,

} from "react-icons/fa";

const GetInTouch = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState({
    type: '',
    msg: ''
  });

  const backend = process.env.REACT_APP_API;

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setStatus({ type: '', msg: '' });

    try {
      const res = await fetch(`${backend}/get-touch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();

      if (data.success) {
        setStatus({
          type: 'success',
          msg: 'Message sent successfully!'
        });

        setFormData({
          name: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        throw new Error("Failed to send");
      }

    } catch (err) {
      setStatus({
        type: 'error',
        msg: 'Something went wrong. Please try again.'
      });

    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact-section">

      <style>{`
        .contact-section {
          padding: clamp(60px, 10vw, 100px) 6%;
          background: #FFF5F7;
          font-family: 'Inter', sans-serif;
        }

        .contact-container {
          max-width: 1200px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1.2fr 0.8fr;
          gap: 60px;
          align-items: center;
        }

        .form-card {
          background: #ffffff;
          padding: clamp(30px, 5vw, 50px);
          border-radius: 32px;
          box-shadow: 0 20px 50px rgba(255, 59, 105, 0.08);
        }

        .form-group {
          margin-bottom: 24px;
          position: relative;
        }

        .form-group label {
          display: block;
          font-size: 14px;
          font-weight: 600;
          color: #111827;
          margin-bottom: 8px;
        }

        .form-group label span {
          color: #ff3b69;
        }

        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 14px 20px;
          border: 1px solid #E5E7EB;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
          outline: none;
        }

        .form-group input:focus,
        .form-group textarea:focus {
          border-color: #ff3b69;
          box-shadow: 0 0 0 4px rgba(255, 59, 105, 0.1);
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #ff3b69, #ff914d);
          color: white;
          border: none;
          border-radius: 12px;
          font-weight: 700;
          font-size: 16px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(255, 59, 105, 0.3);
        }

        .submit-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .info-content h2 {
          font-size: clamp(32px, 5vw, 48px);
          font-weight: 800;
          color: #111827;
          line-height: 1.1;
          margin-bottom: 20px;
        }

        .info-content h2 span {
          color: #ff3b69;
        }

        .info-content p {
          color: #4B5563;
          font-size: 18px;
          line-height: 1.6;
          margin-bottom: 40px;
        }

        .social-wrap h4 {
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: #9CA3AF;
          margin-bottom: 20px;
        }

        .social-links {
          display: flex;
          gap: 15px;
        }

        .social-icon {
          width: 45px;
          height: 45px;
          border-radius: 12px;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ff3b69;
          box-shadow: 0 4px 10px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .social-icon:hover {
          background: #ff3b69;
          color: white;
          transform: translateY(-5px);
        }

        .status-msg {
          margin-bottom: 20px;
          padding: 12px;
          border-radius: 8px;
          font-size: 14px;
          font-weight: 500;
        }

        .status-success {
          background: #DCFCE7;
          color: #166534;
          border: 1px solid #BBF7D0;
        }

        .status-error {
          background: #FEE2E2;
          color: #991B1B;
          border: 1px solid #FECACA;
        }

        @media (max-width: 1024px) {
          .contact-container {
            grid-template-columns: 1fr;
            gap: 50px;
          }

          .info-content {
            order: -1;
            text-align: center;
          }

          .social-links {
            justify-content: center;
          }
        }
      `}</style>

      <div className="contact-container" id="contact">

        <motion.div
          className="form-card"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >

          {status.msg && (
            <div
              className={`status-msg ${status.type === 'success'
                  ? 'status-success'
                  : 'status-error'
                }`}
            >
              {status.msg}
            </div>
          )}

          <form onSubmit={handleSubmit}>

            <div className="form-group">
              <label>
                Your Name <span>*</span>
              </label>

              <input
                type="text"
                placeholder="John Doe"
                required
                value={formData.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    name: e.target.value
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>
                Your Mobile No. <span>*</span>
              </label>

              <input
                type="tel"
                placeholder="+91 00000 00000"
                required
                value={formData.phone}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    phone: e.target.value
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>
                Your Email <span>*</span>
              </label>

              <input
                type="email"
                placeholder="john@example.com"
                required
                value={formData.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    email: e.target.value
                  })
                }
              />
            </div>

            <div className="form-group">
              <label>Message</label>

              <textarea
                rows="4"
                placeholder="How can we help you?"
                value={formData.message}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    message: e.target.value
                  })
                }
              ></textarea>
            </div>

            <button
              type="submit"
              className="submit-btn"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Message"}

              <Send size={18} />
            </button>

          </form>
        </motion.div>

        <motion.div
          className="info-content"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
        >

          <h2>
            Get <span>In Touch</span>
          </h2>

          <p>
            Ready to revolutionize your workforce management?
            Fill out the form and our team will reach out
            to you within 24 hours to schedule a custom demo.
          </p>

          <div className="social-wrap">

            <h4>Follow Us On</h4>

            <div className="social-links">

              <a
                href="https://www.facebook.com/people/Stado-Payroll/61585473567048/"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaFacebook size={20} />
              </a>

              <a
                href="https://www.instagram.com/payroll.stado/"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaInstagram size={20} />
              </a>

              {/* <a
                href="#"
                className="social-icon"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin size={20} />
              </a> */}

            </div>
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default GetInTouch;